import './StepProgress.css';

interface StepProgressProps {
   totalSteps: number;
   currentStep: number;
}
export function StepProgress({ totalSteps, currentStep }: StepProgressProps) {
   return (
      <div className="step-progress flex">
         {[...Array(totalSteps)].map((_, index) => (
            <div
               key={index}
               className={`step ${index < currentStep ? 'active' : ''}`}></div>
         ))}
      </div>
   );
}
